import Base from "./Base";
import HomePage from "@system/config/home-page";
import System from "src/helper/system";
import allTabsCountResponseMaker from "./HomePageContentAPICall/allTabsCountResponseMaker";
import HomePageDocumentContentAPICall from "./HomePageDocumentContentAPICall";
import ProductListingAPICall from "./ProductListingAPICall";
import Api from "./APIHandler";
import { __remove, __set } from "src/store/axios_indicator";

const API = new Api({});
class HomePageContentAPICall extends Base {
    getAllTabsCount = async (params) => {
        let res = {
            data: {}
        };
        __set('ALL_CONTENT_COUNT_API_CALL')
        res.data.contentCount = 0;
        res.data.npiCount = 0;
          if (params.currentTab !== "CNT" || params.currentTab !== "NPIT") {
            let resFromContent = await new HomePageContentAPICall().getContentTabCount(params);
            res.data.contentCount = resFromContent.all;
            res.data.contentTabCount = resFromContent;
            res.data.npiCount = resFromContent.npi
        }

        if (params.currentTab === "NPIT" || params.currentTab === "CNT" || params.currentTab === "DCT") {
            let resProduct = await new ProductListingAPICall().getList(0, 0, { isSkipFacets: true, search: params.searchParam, skipURLParams: true, }, false);
            res.data.productListingCount = resProduct['@odata.count'];
        }

        if (params.currentTab !== "DCT") {
            let resFromDoc = await new HomePageDocumentContentAPICall().getDocumentListCount(params.searchParam);
            res.data.docCount = resFromDoc.data.count;
        }

        let result = await new allTabsCountResponseMaker(res);
        result = await result.process();
        __remove("ALL_CONTENT_COUNT_API_CALL")
        return result.run().get();
    };

    // NEW - DT
    getHomePageContent = async (params) => {
        let res = {};
        let param = {}
        param.data = { ...params, selectedSpeedBoat: System.avUserInfoData.speedBoatAbbr, ...(!params.filterBy && { filterBy: [] }) }
        await API.post(HomePage.ALL_CONTENT_TAB, param).then((resHer) => {
            res = resHer.data;
        }).catch((e) => {
        })
        return res;
    }

    getContentTabCount = async (params) => {
        let reqData = {
            data: { searchTerm: params.searchParam, selectedSpeedBoat: System.avUserInfoData.speedBoatAbbr, "filterBy": [], "contentType": "" }
        };

        let res = {};
        await API.post(HomePage.CONTENT_TAB_COUNT_NEW, reqData).then((response) => {
            res = response.data.data;
        });
        return res;
    };


}

export default HomePageContentAPICall;